module.exports = {"domain":"one-hour.fr","weekLimit":13,"prodTag":true}


//////////////////
// WEBPACK FOOTER
// ./src/utils.json
// module id = 97
// module chunks = 51